import { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import Select, { components } from "react-select";
import LoadingIcon from "../../components/LoadingIcon";
import { toast } from "react-toastify";
import { FaPen, FaTrash } from "react-icons/fa";
import { DeliveryOrderWarehouse } from "./DeliveryOrderWarehouse";
import { DeliveryOrderTrucker } from "./DeliveryOrderTrucker";
import "../../stylesheets/Modal.scss";
import "../../stylesheets/Warehouse.scss";


export const DeliveryOrder = ({ x, id, handleDelete, handleNewDelete }) => {
  const cookies = new Cookies();
  const token = cookies.get("token_user");
  const URL = process.env.REACT_APP_API_URL + "/user";

  const [selectedTrucker, setSelectedTrucker] = useState(0);
  const [selectedWarehouse, setSelectedWarehouse] = useState(0);

  const [selectedContainers, setSelectedContainers] = useState([]);
  const [newReferenceNumber, setNewReferenceNumber] = useState("");
  const [newNote, setNewNote] = useState("");
  const [openDO, setOpenDO] = useState(true);

  const [masterBillLading, setMasterBillLading] = useState([]);
  const [houseBillLading, setHouseBillLading] = useState([]);

  const [selectedMasterBillLading, setSelectedMasterBillLading] = useState([]);
  const [selectedHouseBillLading, setSelectedHouseBillLading] = useState([]);

  const [billLading, setBillLading] = useState();
  const [selectedBills, setSelectedBills] = useState([]);

  const [shipment, setShipment] = useState();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    trucker: false,
    warehouse: false,
    container: false,
  });
  const [error, setError] = useState("");
  const [saveLoading2, setSaveLoading2] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isNew, setIsNew] = useState(true);

  const [warehouseModalIsOpen, setWarehouseModalIsOpen] = useState(false);
  const [truckerModalIsOpen, setTruckerModalIsOpen] = useState(false);
  const [editingTruckerInfo, setEditingTruckerInfo] = useState(null);
  const [editingWarehouseInfo, setEditingWarehouseInfo] = useState(null);

  const [selectedExtraEmailOptions, setSelectedExtraEmailOptions] = useState([]);

  const activeTruckers = shipment?.truckers?.filter((trucker) => trucker.status == "1") || [];
  const activeWarehouses = shipment?.warehouses?.filter((warehouse) => warehouse.status == "1") || [];

  const deliveryOrderTrucker = shipment?.delivery_orders?.[x]?.trucker;
  const deliveryOrderWarehouse = shipment?.delivery_orders?.[x]?.warehouse;

  const truckerOptions = [
    { value: "add-new", label: "Add New Trucker" },
    ...activeTruckers
      .map((trucker) => ({
        value: trucker.id,
        label: trucker.name,
      }))
      .sort((a, b) => (a.label || "").localeCompare(b.label || "")),
  ];

  if (deliveryOrderTrucker && deliveryOrderTrucker.deleted_at) {
    truckerOptions.push({
      value: deliveryOrderTrucker.id,
      label: `${deliveryOrderTrucker.name} (Deleted)`,
    });
  }
  const warehouseOptions = [
    { value: "add-new", label: "Add New Warehouse" },
    ...activeWarehouses
      .map((warehouse) => ({
        value: warehouse.id,
        label: warehouse.name,
      }))
      .sort((a, b) => (a.label || "").localeCompare(b.label || "")),
  ];

  if (deliveryOrderWarehouse && deliveryOrderWarehouse.deleted_at) {
    warehouseOptions.push({
      value: deliveryOrderWarehouse.id,
      label: `${deliveryOrderWarehouse.name} (Deleted)`,
    });
  }
  const openWarehouseModal = () => {
    setEditingWarehouseInfo(null);
    setWarehouseModalIsOpen(true);
  };

  const openEditWarehouseModal = () => {
    const curWarehouse =
      shipment?.warehouses?.find((w) => w.id == selectedWarehouse) ||
      (shipment?.delivery_orders?.[x]?.warehouse?.id == selectedWarehouse
        ? shipment.delivery_orders[x].warehouse
        : null);
    if (curWarehouse) {
      setEditingWarehouseInfo(curWarehouse);
      setWarehouseModalIsOpen(true);
    }
  };

  const closeWarehouseModal = () => {
    setWarehouseModalIsOpen(false);
    setEditingWarehouseInfo(null);
  };

  const openTruckerModal = () => {
    setEditingTruckerInfo(null);
    setTruckerModalIsOpen(true);
  };

  const openEditTruckerModal = () => {
    const curTrucker =
      shipment?.truckers?.find((t) => t.id == selectedTrucker) ||
      (shipment?.delivery_orders?.[x]?.trucker?.id == selectedTrucker
        ? shipment.delivery_orders[x].trucker
        : null);
    if (curTrucker) {
      setEditingTruckerInfo(curTrucker);
      setTruckerModalIsOpen(true);
    }
  };

  const closeTruckerModal = () => {
    setTruckerModalIsOpen(false);
    setEditingTruckerInfo(null);
  };

  const getShipmentData = async (resetSelection = true) => {
    setLoading(true);
    try {
      const resp = await fetch(`${URL}/shipments/details/${id}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await resp.json();
      setShipment(data?.shipment);

      // Prefill data
      if (data?.shipment?.containers?.length) {
        if (data?.shipment?.containers?.length < 2) {
          setSelectedContainers([
            { container_id: data?.shipment?.containers[0]?.id },
          ]);
        }
        if (data.shipment.delivery_orders[x]) {
          setIsNew(false);
          setNewReferenceNumber(
            data?.shipment?.delivery_orders[x]?.reference_number
          );

          // Only set selected trucker and warehouse if resetSelection is true
          if (resetSelection) {
            if (data?.shipment?.delivery_orders[x]?.trucker_id) {
              const doTrucker = data?.shipment?.delivery_orders[x]?.trucker;
              let truckerId = data?.shipment?.delivery_orders[x]?.trucker_id;
              // If the trucker is deleted, find an active one with the same name
              if (doTrucker?.deleted_at) {
                const match = data?.shipment?.truckers?.find(
                  (t) => t.name === doTrucker.name && t.status === "1" && !t.deleted_at
                );
                if (match) truckerId = match.id;
              }
              setSelectedTrucker(truckerId);
            }
            if (data?.shipment?.delivery_orders[x]?.warehouse_id) {
              const doWarehouse = data?.shipment?.delivery_orders[x]?.warehouse;
              let warehouseId = data?.shipment?.delivery_orders[x]?.warehouse_id;
              // If the warehouse is deleted, find an active one with the same name
              if (doWarehouse?.deleted_at) {
                const match = data?.shipment?.warehouses?.find(
                  (w) => w.name === doWarehouse.name && w.status == "1" && !w.deleted_at
                );
                if (match) warehouseId = match.id;
              }
              setSelectedWarehouse(warehouseId);
            }
          }

          if (
            data?.shipment?.delivery_orders[x]?.delivery_order_containers &&
            data?.shipment?.containers?.length > 1
          ) {
            const tempContainers =
              data?.shipment?.delivery_orders[x]?.delivery_order_containers;
            setSelectedContainers(
              tempContainers.map((i) => ({
                container_id: i?.container_id,
                container_no: i?.container?.container_no,
              }))
            );
          }
          if (data?.shipment?.delivery_orders[x]?.note !== "No note provided") {
            setNewNote(data?.shipment?.delivery_orders[x]?.note);
          }
          if (data?.shipment?.delivery_orders[x]?.bill_ladings?.length > 0) {
            let temp_master = [];
            let temp_house = [];

            let landing = [];
            let landingSelected = [];
            data?.shipment?.delivery_orders[x]?.bill_ladings?.forEach((bill) => {
              landing.push(bill);
              landingSelected.push(bill?.id);
              if (bill?.is_master_bill_lading === 1) {
                temp_master.push({ label: bill?.bill_lading, value: bill?.id });
              } else if (bill?.is_master_bill_lading === 0) {
                temp_house.push({ label: bill?.bill_lading, value: bill?.id });
              }
            });
            setSelectedHouseBillLading(temp_house);
            setSelectedMasterBillLading(temp_master);

            setBillLading(landing);
            setSelectedBills(landingSelected);

            if (Array.isArray(data?.shipment?.delivery_orders[x]?.extra_cc_emails)) {
              setSelectedExtraEmailOptions(
                data.shipment.delivery_orders[x].extra_cc_emails.map((email) => ({
                  value: email,
                  label: email,
                }))
              );
            }

          }
        } else {
          setNewReferenceNumber(data?.shipment?.customer_reference_no);
        }
      }

      setLoading(false);
    } catch (e) {
      //console.log(e);
      alert("Server not responding, please contact us.");
    }
  };

  const handleNewContainer = (containers) => {
    setErrors({ ...errors, containers: false });

    if (!containers || containers.length === 0) {
      setSelectedContainers([]);
      return;
    }

    const hasAddAll = containers.some((c) => c.value === "add-all");
    let selected = containers;

    if (hasAddAll) {
      // Replace selection with all available containers (excluding "Add All")
      selected = formatContainers(shipment.containers).filter(
        (c) => c.value !== "add-all"
      );
    }

    setSelectedContainers(
      selected.map((container) => ({
        container_id: container?.value,
        container_no: container?.label,
      }))
    );
  };

  const removedAllContainers = () => {
    setSelectedContainers([]);
  };

  const handleNewWarehouse = (newWarehouse) => {
    //console.log('entro en new warehouse ', newWarehouse);
    setSelectedWarehouse(newWarehouse.id); // Set selected warehouse first
    setShipment((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        warehouses: [newWarehouse, ...prev.warehouses],
      },
    }));
    // Fetch updated shipment data without overwriting the selected state
    getShipmentData(false); // Adjust getShipmentData to not reset the state
  };

  const handleNewTrucker = (newTrucker) => {
    //console.log('entro en new trucker', newTrucker);
    setSelectedTrucker(newTrucker.id); // Set selected trucker first
    setShipment((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        truckers: [newTrucker, ...prev.truckers],
      },
    }));
    // Fetch updated shipment data without overwriting the selected state
    getShipmentData(false); // Adjust getShipmentData to not reset the state
  };

  const formatContainers = (dbContainers) => {
    const deliveryOrderList = new Set();
    const rawContainers = [];

    shipment?.delivery_orders?.forEach((d) => {
      d.delivery_order_containers.forEach((c) => {
        if (c?.container_id) {
          deliveryOrderList.add(c.container_id);
        }
      });
    });

    dbContainers.forEach((c) => {
      const isAssigned = deliveryOrderList.has(c.id);
      rawContainers.push({
        label: `${c.container_no}${isAssigned ? " (Assigned)" : ""}`,
        value: c.id,
      });
    });

    // Add "Add All" option when there is more than one container
    if (rawContainers.length > 1) {
      return [{ label: "Add All", value: "add-all" }, ...rawContainers];
    }

    return rawContainers;
  };

  const sendDeliveryOrder = async (e) => {
    e.preventDefault();
    const shipmentId = id;
    const doId = shipment?.delivery_orders[x]?.id;

    //setSendLoading(true);

    try {
      const response = await fetch(
        `${URL}/shipments/${shipmentId}/delivery_order/${doId}/send`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json",
          },
        }
      );
      const result = await response.json();

      if (response.status === 200) {
        //console.log("Delivery Order sent successfully");
        toast.success("Delivery Order sent successfully!");
      } else {
        console.error("Error sending Delivery Order:", result.errors[0]);
        toast.error("Error sending Delivery Order. Please try again later.");
      }
    } catch (error) {
      console.error("Failed to send Delivery Order:", error);
      toast.error("Something went wrong. Please, try again in a few minutes!");
    } finally {
      //setSendLoading(false);
    }
  };

  const updateOrder = async (e) => {
    e.preventDefault();
    setSaveLoading2(true);

    var tempContainers = selectedContainers;

    var data = {
      trucker_id: selectedTrucker,
      warehouse_id: selectedWarehouse,
      reference_number: newReferenceNumber,
      note: newNote,
      containers: selectedContainers,
      bill_ladings: billLading,
      extra_cc_emails:
        selectedExtraEmailOptions && selectedExtraEmailOptions.length > 0
          ? selectedExtraEmailOptions.map((opt) => opt.value)
          : [],
    };

    // Handle Errors
    var curErrors = {
      trucker: false,
      warehouse: false,
      container: false,
      bills: false,
    };
    var hasError = false;

    if (!data?.trucker_id) {
      curErrors.trucker = true;
      hasError = true;
    }
    if (!data?.warehouse_id) {
      curErrors.warehouse = true;
      hasError = true;
    }
    if (!data?.containers || data?.containers?.length < 1) {
      curErrors.containers = true;
      hasError = true;
    }
    if (!billLading || billLading?.length <= 0) {
      curErrors.bills = true;
      hasError = true;
    }
    setErrors(curErrors);

    if (hasError) {
      setSaveLoading2(false);
      return;
    }

    // if (data.note == null) {
    //   data.note = "No note provided";
    // }

    try {
      const resp = await fetch(
        `${URL}/shipments/${id}/delivery_order/${shipment?.delivery_orders[x]?.id}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json",
          },
          body: JSON.stringify(data), //each individual file object
        }
      );
      const fin = await resp.json();

      if (resp.status == 200) {
        setLoading(false);
        setSaveLoading2(false);
        toast.success("Delivery Order updated successfully!");
      } else {
        setLoading(false);
        setSaveLoading2(false);
        setError(fin?.errors[0]);
        console.log(
          `There was an error uploading the Delivery Order, try again`
        );
        toast.error(
          "Something went wrong. Please, try again in a few minutes!"
        );
      }
    } catch (e) {
      toast.error("Something went wrong. Please, try again in a few minutes!");
    }
  };

  const deleteOrder = async (e) => {
    e.preventDefault();
    setDeleteLoading(true);

    if (shipment.delivery_orders[x]) {
      try {
        const resp = await fetch(
          `${URL}/shipments/${id}/delivery_order/${shipment?.delivery_orders[x]?.id}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-type": "application/json",
            },
          }
        );

        const fin = await resp.json();

        if (resp?.status == 200) {
          handleDelete();
          setDeleteLoading(false);
        } else {
          setDeleteLoading(false);
          toast.error(
            "Something went wrong. Please, try again in a few minutes!"
          );
        }
      } catch (e) {
        toast.error(
          "Something went wrong. Please, try again in a few minutes!"
        );
      }
    } else {
      handleNewDelete();
      setDeleteLoading(false);
    }
  };

  const [doError, setDoError] = useState(false);

  const extraEmailOptions = (() => {
    if (
      !shipment ||
      !shipment.extra_delivery_order_emails ||
      shipment.extra_delivery_order_emails.length === 0
    ) {
      return [];
    }

    const emailsSet = new Set();

    shipment.extra_delivery_order_emails.forEach((row) => {
      if (Array.isArray(row.cc_emails)) {
        row.cc_emails.forEach((email) => {
          const trimmed = email ? email.trim() : "";
          if (trimmed.length > 0) {
            emailsSet.add(trimmed);
          }
        });
      }
    });

    const baseOptions = Array.from(emailsSet)
      .map((email) => ({
        value: email,
        label: email,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

    // Add "Add All" only if we have more than one
    return baseOptions.length > 1
      ? [{ value: "add-all", label: "Add All" }, ...baseOptions]
      : baseOptions;
  })();

  // Handle select change for extra DO emails
  const handleExtraEmailsChange = (selected) => {
    if (!selected || selected.length === 0) {
      setSelectedExtraEmailOptions([]);
      return;
    }

    const hasAddAll = selected.some((opt) => opt.value === "add-all");

    if (hasAddAll) {
      const all = extraEmailOptions.filter((opt) => opt.value !== "add-all");
      setSelectedExtraEmailOptions(all);
    } else {
      setSelectedExtraEmailOptions(selected);
    }
  };

  const [deletingEmail, setDeletingEmail] = useState(null);

  const handleDeleteExtraEmail = async (emailValue) => {
    if (deletingEmail) return;
    setDeletingEmail(emailValue);
    try {
      const resp = await fetch(`${URL}/extra-delivery-order-email`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ email: emailValue }),
      });
      if (resp.ok) {
        toast.success("Email removed from list.");
        // Deselect it if it was selected, then refresh
        setSelectedExtraEmailOptions((prev) =>
          prev.filter((opt) => opt.value !== emailValue)
        );
        await getShipmentData(false);
      } else {
        const data = await resp.json();
        toast.error(data?.message || "Failed to remove email.");
      }
    } catch {
      toast.error("Failed to remove email.");
    } finally {
      setDeletingEmail(null);
    }
  };

  const newOrder = async (e) => {
    e.preventDefault();
    setSaveLoading2(true);

    var data = {
      trucker_id: selectedTrucker,
      warehouse_id: selectedWarehouse,
      reference_number: newReferenceNumber,
      note: newNote,
      containers: selectedContainers,
      bill_ladings: billLading,
      extra_cc_emails:
        selectedExtraEmailOptions && selectedExtraEmailOptions.length > 0
          ? selectedExtraEmailOptions.map((opt) => opt.value)
          : [],
    };

    // Handle Errors
    var curErrors = {
      trucker: false,
      warehouse: false,
      container: false,
      bills: false,
    };
    var hasError = false;

    if (!data?.trucker_id) {
      curErrors.trucker = true;
      hasError = true;
    }
    if (!data?.warehouse_id) {
      curErrors.warehouse = true;
      hasError = true;
    }
    if (!data?.containers || data?.containers?.length < 1) {
      curErrors.containers = true;
      hasError = true;
    }
    if (!billLading || billLading?.length <= 0) {
      curErrors.bills = true;
      hasError = true;
    }
    setErrors(curErrors);

    if (hasError) {
      setSaveLoading2(false);
      return;
    }

    try {
      const resp = await fetch(`${URL}/shipments/${id}/delivery_order`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const fin = await resp.json();
      getShipmentData(false); // Fetch updated data without resetting selection

      if (resp?.status == 200) {
        setIsNew(false);
        setSaveLoading2(false);
        //console.log(`Delivery Order successfully created!`);
        setDoError(false);
      } else {
        setSaveLoading2(false);
        toast.error(
          "Something went wrong. Please, try again in a few minutes!"
        );
        setDoError(true);
      }
    } catch (e) {
      toast.error("Something went wrong. Please, try again in a few minutes!");
    }
  };

  const handleMasterBillOfLading = (selected) => {
    if (!selected || selected.length === 0) {
      setSelectedMasterBillLading([]);
      return;
    }

    const hasAddAll = selected.some((bill) => bill.value === "add-all");

    if (hasAddAll) {
      // Select all master BLs (excluding "Add All")
      const allMasters =
        shipment?.bill_lading
          ?.filter((bill) => bill?.is_master_bill_lading == 1)
          .map((bill) => ({
            value: bill.id,
            label: bill.bill_lading,
          })) || [];

      setSelectedMasterBillLading(allMasters);
    } else {
      setSelectedMasterBillLading(selected);
    }
  };

  const handleHouseBillOfLading = (selected) => {
    if (!selected || selected.length === 0) {
      setSelectedHouseBillLading([]);
      return;
    }

    const hasAddAll = selected.some((bill) => bill.value === "add-all");

    if (hasAddAll) {
      // Select all house BLs (excluding "Add All")
      const allHouses =
        shipment?.bill_lading
          ?.filter((bill) => bill?.is_master_bill_lading == 0)
          .map((bill) => ({
            value: bill.id,
            label: bill.bill_lading,
          })) || [];

      setSelectedHouseBillLading(allHouses);
    } else {
      setSelectedHouseBillLading(selected);
    }
  };

  useEffect(() => {
    let final = [...selectedMasterBillLading, ...selectedHouseBillLading];
    const finalBillArray = final.map((bill) => bill?.value);
    setBillLading(finalBillArray);
  }, [selectedMasterBillLading, selectedHouseBillLading]);

  const handleDOTab = () => {
    if (openDO == false) {
      setOpenDO(true);
    } else {
      setOpenDO(false);
    }
  };

  useEffect(() => {
    getShipmentData();
  }, []);

  const isBrisAccount = shipment?.account_no === "BRIS";

  return (
    <>
      <Modal isOpen={warehouseModalIsOpen} onClose={closeWarehouseModal}>
        <DeliveryOrderWarehouse
          index={null}
          warehouseInfo={editingWarehouseInfo}
          isNew={!editingWarehouseInfo}
          emailError={false}
          closeModal={closeWarehouseModal}
          addWarehouse={handleNewWarehouse}
          setSelectedWarehouse={setSelectedWarehouse}
        />
      </Modal>

      <Modal isOpen={truckerModalIsOpen} onClose={closeTruckerModal}>
        <DeliveryOrderTrucker
          truckerInfo={editingTruckerInfo}
          isNew={!editingTruckerInfo}
          addTrucker={handleNewTrucker}
          closeModal={closeTruckerModal}
        />
      </Modal>

      {typeof shipment === "undefined" || loading ? (
        <div className="delivery-order-container">
          <h3>Loading...</h3>
        </div>
      ) : (
        <div className="delivery-order-container">
          <div className="tab-header" onClick={handleDOTab}>
            <p className="title">Delivery Order #{x + 1}</p>
            {openDO ? (
              <span className="arrow">
                <svg width="10.317" height="7.317" viewBox="0 0 10.317 7.317">
                  <g transform="translate(1.408 1.408)">
                    <line
                      y1="4.5"
                      x2="3.75"
                      fill="none"
                      stroke="#303030"
                      strokeLinecap="round"
                      strokeWidth="2"
                    />
                    <line
                      x1="3.75"
                      y1="4.5"
                      transform="translate(3.75)"
                      fill="none"
                      stroke="#303030"
                      strokeLinecap="round"
                      strokeWidth="2"
                    />
                  </g>
                </svg>
              </span>
            ) : (
              <span className="arrow">
                <svg width="10.317" height="7.317" viewBox="0 0 10.317 7.317">
                  <g transform="translate(-188.092 -344.092)">
                    <line
                      x2="3.75"
                      y2="4.5"
                      transform="translate(189.5 345.5)"
                      fill="none"
                      stroke="#303030"
                      strokeLinecap="round"
                      strokeWidth="2"
                    />
                    <line
                      x1="3.75"
                      y2="4.5"
                      transform="translate(193.25 345.5)"
                      fill="none"
                      stroke="#303030"
                      strokeLinecap="round"
                      strokeWidth="2"
                    />
                  </g>
                </svg>
              </span>
            )}
          </div>
          <form
            className="delivery-order_form"
            style={openDO ? { display: "flex" } : { display: "none" }}
          >
            <div className={`input-box select-trucker ${errors.trucker ? "error" : ""}`}>
              <label>
                <p>Trucker</p>
              </label>
              <Select
                components={{
                  DropdownIndicator: (props) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {selectedTrucker && selectedTrucker !== "add-new" ? (
                        <div
                          role="button"
                          tabIndex={0}
                          onMouseDown={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            openEditTruckerModal();
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            openEditTruckerModal();
                          }}
                          title="Edit selected trucker"
                          style={{
                            cursor: "pointer",
                            padding: "0 6px",
                            display: "flex",
                            alignItems: "center",
                            color: "#707070",
                          }}
                          onMouseEnter={(e) => (e.currentTarget.style.color = "#1070ff")}
                          onMouseLeave={(e) => (e.currentTarget.style.color = "#707070")}
                        >
                          <FaPen size={11} />
                        </div>
                      ) : null}
                      <components.DropdownIndicator {...props} />
                    </div>
                  ),
                }}
                options={[
                  { value: "add-new", label: "Add New Trucker" },
                  // Active truckers
                  ...shipment.truckers
                    .filter((trucker) => trucker.status == "1")
                    .map((trucker) => ({
                      value: trucker.id,
                      label: trucker.name,
                    })),
                  // Add the deleted trucker if attached to this delivery order
                  ...(shipment.delivery_orders[x]?.trucker?.deleted_at &&
                    !shipment.truckers.find((t) => t.id === shipment.delivery_orders[x].trucker.id)
                    ? [{
                      value: shipment.delivery_orders[x].trucker.id,
                      label: `${shipment.delivery_orders[x].trucker.name} (Deleted)`,
                    }]
                    : []),
                ]}
                onChange={(e) => {
                  if (e.value === "add-new") {
                    openTruckerModal();
                  } else {
                    setErrors({ ...errors, trucker: false });
                    setSelectedTrucker(e.value);
                  }
                }}
                value={
                  selectedTrucker !== 0
                    ? {
                      value: selectedTrucker,
                      label:
                        shipment.truckers.find((t) => t.id == selectedTrucker)?.name ||
                        (shipment.delivery_orders[x]?.trucker?.name
                          ? `${shipment.delivery_orders[x]?.trucker?.name}${shipment.delivery_orders[x]?.trucker?.deleted_at ? " (Deleted)" : ""
                          }`
                          : "Select Trucker"),
                    }
                    : null
                }
                placeholder="Select Trucker"
              />
            </div>

            <div className={`input-box select-warehouse ${errors.warehouse ? "error" : ""}`}>
              <label>
                <p>Warehouse</p>
              </label>
              <Select
                components={{
                  DropdownIndicator: (props) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {selectedWarehouse && selectedWarehouse !== "add-new" ? (
                        <div
                          role="button"
                          tabIndex={0}
                          onMouseDown={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            openEditWarehouseModal();
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            openEditWarehouseModal();
                          }}
                          title="Edit selected warehouse"
                          style={{
                            cursor: "pointer",
                            padding: "0 6px",
                            display: "flex",
                            alignItems: "center",
                            color: "#707070",
                          }}
                          onMouseEnter={(e) => (e.currentTarget.style.color = "#1070ff")}
                          onMouseLeave={(e) => (e.currentTarget.style.color = "#707070")}
                        >
                          <FaPen size={11} />
                        </div>
                      ) : null}
                      <components.DropdownIndicator {...props} />
                    </div>
                  ),
                }}
                options={[
                  { value: "add-new", label: "Add New Warehouse" },
                  // Active warehouses
                  ...shipment.warehouses
                    .filter((warehouse) => warehouse.status == "1")
                    .map((warehouse) => ({
                      value: warehouse.id,
                      label: warehouse.name,
                    })),
                  // Add deleted warehouse if assigned to DO
                  ...(shipment.delivery_orders[x]?.warehouse?.deleted_at &&
                    !shipment.warehouses.find((w) => w.id === shipment.delivery_orders[x].warehouse.id)
                    ? [{
                      value: shipment.delivery_orders[x].warehouse.id,
                      label: `${shipment.delivery_orders[x].warehouse.name} (Deleted)`,
                    }]
                    : []),
                ]}
                onChange={(e) => {
                  if (e.value === "add-new") {
                    openWarehouseModal();
                  } else {
                    setErrors({ ...errors, warehouse: false });
                    setSelectedWarehouse(e.value);
                  }
                }}
                value={
                  selectedWarehouse !== 0
                    ? {
                      value: selectedWarehouse,
                      label:
                        shipment.warehouses.find((w) => w.id == selectedWarehouse)?.name ||
                        (shipment.delivery_orders[x]?.warehouse?.name
                          ? `${shipment.delivery_orders[x]?.warehouse?.name}${shipment.delivery_orders[x]?.warehouse?.deleted_at ? " (Deleted)" : ""
                          }`
                          : "Select Warehouse"),
                    }
                    : null
                }
                placeholder="Select Warehouse"
              />
            </div>

            {shipment?.bill_lading?.filter(
              (bill) => bill?.is_master_bill_lading == 1
            ).length > 0 && (
                <div
                  className={`input-box select-container ${errors.bills ? "error" : ""
                    }`}
                >
                  <label>
                    <p>Master Bill of Lading</p>
                  </label>
                  <Select
                    isMulti={true}
                    options={(() => {
                      const masters =
                        shipment?.bill_lading
                          ?.filter((bill) => bill?.is_master_bill_lading == 1)
                          .map((bill) => ({
                            value: bill.id,
                            label: bill.bill_lading,
                          })) || [];

                      return masters.length > 1
                        ? [{ value: "add-all", label: "Add All" }, ...masters]
                        : masters;
                    })()}
                    value={selectedMasterBillLading}
                    onChange={(e) => {
                      handleMasterBillOfLading(e || []);
                    }}
                  />
                </div>
              )}

            {shipment?.bill_lading?.filter(
              (bill) => bill?.is_master_bill_lading == 0
            ).length > 0 && (
                <div
                  className={`input-box select-container ${errors.bills ? "error" : ""
                    }`}
                >
                  <label>
                    <p>House Bill of Lading</p>
                  </label>
                  <Select
                    isMulti={true}
                    options={(() => {
                      const houses =
                        shipment?.bill_lading
                          ?.filter((bill) => bill?.is_master_bill_lading == 0)
                          .map((bill) => ({
                            value: bill.id,
                            label: bill.bill_lading,
                          })) || [];

                      return houses.length > 1
                        ? [{ value: "add-all", label: "Add All" }, ...houses]
                        : houses;
                    })()}
                    value={selectedHouseBillLading}
                    onChange={(e) => {
                      handleHouseBillOfLading(e || []);
                    }}
                  />
                </div>
              )}

            <div
              className={`input-box select-container ${errors.containers ? "error" : ""
                }`}
            >
              <label>
                <p>
                  {shipment.containers.length > 1 ? "Containers" : "Container"}
                </p>
              </label>
              {shipment.containers.length > 1 ? (
                <Select
                  isMulti={true}
                  options={formatContainers(shipment.containers)}
                  value={selectedContainers.map((i) => ({
                    label: i.container_no,
                    value: i.container_id,
                  }))}
                  onChange={(e) => {
                    if (!e || e.length === 0) {
                      removedAllContainers();
                      return;
                    }
                    handleNewContainer(e);
                  }}
                />
              ) : (
                <input
                  type="text"
                  value={shipment.containers[0]?.container_no}
                  disabled={true}
                  className="text-input"
                />
              )}

            </div>
            <div className="input-box reference_number">
              <label>
                <p>Reference Number</p>
              </label>
              <input
                type="text"
                placeholder={shipment.customer_reference_no}
                value={newReferenceNumber}
                onChange={(e) => setNewReferenceNumber(e.target.value)}
                className="text-input"
              />
            </div>

            {isBrisAccount && (
              <div className="input-box select-container">
                <label>
                  <p>Extra Delivery Order Emails</p>
                </label>
                <Select
                  isMulti={true}
                  options={extraEmailOptions}
                  value={selectedExtraEmailOptions}
                  onChange={(e) => handleExtraEmailsChange(e || [])}
                  placeholder={
                    extraEmailOptions.length
                      ? "Select Extra Emails"
                      : "No extra emails configured"
                  }
                  isDisabled={!extraEmailOptions.length}
                  components={{
                    Option: ({ children, ...props }) => (
                      <components.Option {...props}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "8px",
                          }}
                        >
                          <span>{children}</span>
                          {props.data.value !== "add-all" && (
                            <button
                              title="Delete this email"
                              disabled={deletingEmail === props.data.value}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleDeleteExtraEmail(props.data.value);
                              }}
                              style={{
                                flexShrink: 0,
                                background: "none",
                                border: "none",
                                cursor: deletingEmail === props.data.value ? "wait" : "pointer",
                                padding: "2px 4px",
                                color: deletingEmail === props.data.value ? "#aaa" : "#e53e3e",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <FaTrash size={12} />
                            </button>
                          )}
                        </div>
                      </components.Option>
                    ),
                  }}
                />
              </div>
            )}

            <div className="delivery-order_note">
              <label>
                <p>Notes</p>
              </label>
              <textarea
                name="delviery_note"
                id="delviery_note"
                value={newNote}
                onChange={(e) => {
                  setNewNote(e.target.value);
                }}
              ></textarea>
            </div>
            {doError && (
              <p
                className="error-message"
                style={{
                  background: "var(--global-red)",
                  border: "1px solid var(--red)",
                  color: "var(--red)",
                  padding: "6px 12px",
                  borderRadius: "5px",
                }}
              >
                This shipment is still missing a container number. Please wait
                for that information to be available or contact{" "}
                <a
                  href="mailto:info@atlanticbrokers.com"
                  style={{ textDecoration: "underline" }}
                >
                  info@atlanticbrokers.com
                </a>
              </p>
            )}
            <div className="buttons">
              <button className="delete" onClick={(e) => deleteOrder(e)}>
                {deleteLoading ? <LoadingIcon /> : "Delete"}
              </button>
              <button
                type="submit"
                className="submit"
                onClick={(e) => {
                  isNew ? newOrder(e) : updateOrder(e);
                }}
              >
                {saveLoading2 ? <LoadingIcon /> : "Save"}
              </button>
              {shipment?.delivery_orders[x]?.approved && (
                <button
                  type="submit"
                  className="submit"
                  onClick={sendDeliveryOrder}
                >
                  {sendLoading ? <LoadingIcon /> : "Send"}
                </button>
              )}
            </div>
          </form>
          <p className="error-message">{error}</p>
        </div>
      )}
    </>
  );
};

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div className="modal-overlay">
      <div className="modal">
        <button onClick={onClose} className="close-modal">
          Close
        </button>
        {children}
      </div>
    </div>
  );
};
